import { Component, signal } from '@angular/core';
import { HOME_SLIDES } from '../../core/constants/home-slider';

@Component({
  selector: 'app-home-slider',
  host: { class: 'home-revslider-block' },
  templateUrl: './home-slider.component.html'
})
export class HomeSliderComponent {
  readonly slides = HOME_SLIDES;
  readonly active = signal(0);

  goTo(index: number): void {
    this.active.set(index);
  }

  prev(event: Event): void {
    event.preventDefault();
    this.active.update((current) => (current - 1 + this.slides.length) % this.slides.length);
  }

  next(event?: Event): void {
    event?.preventDefault();
    this.active.update((current) => (current + 1) % this.slides.length);
  }
}
